export default __webpack_public_path__ + "static/media/map.fe2f32fd.jpg";